module.exports = __webpack_public_path__ + "static/img/logo-experience.a68f4430.png";